export default __webpack_public_path__ + "static/media/RegionsBank.768cd97e.svg";